module.exports = __webpack_public_path__ + "img/stack07.efed84ab.svg";